const trimTrailingSlash = (value) => {
  if (!value || typeof value !== "string") return "";
  return value.replace(/\/+$/, "");
};

const getBrowserOrigin = () => {
  if (typeof window === "undefined") return "";
  return trimTrailingSlash(window.location.origin);
};

const fromWindowConfig = (key) => {
  if (typeof window === "undefined") return "";
  const cfg = window.__APP_CONFIG__;
  if (!cfg || typeof cfg !== "object") return "";
  const value = cfg[key];
  return typeof value === "string" ? value.trim() : "";
};

const fromEnv = (key) => {
  const runtimeValue = fromWindowConfig(key);
  if (runtimeValue) return runtimeValue;
  const value = import.meta.env[key];
  return typeof value === "string" ? value.trim() : "";
};

const browserOrigin = getBrowserOrigin();

const inferApiBaseUrlFromHost = () => {
  if (typeof window === "undefined") return "";
  const { protocol, hostname } = window.location;
  if (hostname.includes("mlm-frontend")) {
    return `${protocol}//${hostname.replace("mlm-frontend", "mlm-vii-api")}`;
  }
  return "";
};

const apiBaseUrl =
  trimTrailingSlash(fromEnv("VITE_API_BASE_URL")) ||
  trimTrailingSlash(fromEnv("VITE_AUTH_BASE_URL")) ||
  trimTrailingSlash(inferApiBaseUrlFromHost()) ||
  browserOrigin;

const authBaseUrl =
  trimTrailingSlash(fromEnv("VITE_AUTH_BASE_URL")) || apiBaseUrl;

const graphQLUrl =
  trimTrailingSlash(fromEnv("VITE_GRAPHQL_URL")) || `${apiBaseUrl}/graphql`;

const appBaseUrl =
  trimTrailingSlash(fromEnv("VITE_APP_BASE_URL")) || browserOrigin;

const parseEnvId = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};

const defaultEnvironmentId =
  parseEnvId(fromEnv("VITE_DEFAULT_ENVIRONMENT_ID")) ||
  parseEnvId(fromEnv("VITE_ENVIRONMENT_ID")) ||
  10403;

const fallbackAuthApiKey =
  fromEnv("VITE_AUTH_API_KEY") || fromEnv("VITE_API_KEY");

const parseTimeoutMs = (value, fallback) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const graphqlTimeoutMs = parseTimeoutMs(fromEnv("VITE_GRAPHQL_TIMEOUT_MS"), 60000);
const requestTimeoutMs = parseTimeoutMs(fromEnv("VITE_REQUEST_TIMEOUT_MS"), graphqlTimeoutMs);

const payQuickerServiceUrl = trimTrailingSlash(fromEnv("VITE_PAYQUICKER_SERVICE_URL"));

export {
  apiBaseUrl,
  authBaseUrl,
  appBaseUrl,
  graphQLUrl,
  defaultEnvironmentId,
  fallbackAuthApiKey,
  graphqlTimeoutMs,
  requestTimeoutMs,
  payQuickerServiceUrl,
};
